module.exports = __webpack_public_path__ + "54cf98f5/img/comments-icon.fdec7fdb.svg";